import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { commonAPI } from 'api/commonAPI';
import Check from 'assets/images/icon/Check';
import CloseIcon from 'assets/images/icon/CloseIcon';
import PlusIcon from 'assets/images/icon/PlusIcon';
import Remove from 'assets/images/icon/Remove';
import axios from 'axios';
import {constCommon, returnChapterId} from 'constants/constCommon';
import useGetClassData from 'hooks/useGetClassData';
import { cloneDeep } from 'lodash';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import {
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from 'recoil';
import {
    activeSubmit, Alert,
    fireSubmit,
    selectedMenu,
} from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import {
  DropdownMenu,
  Icon,
} from 'view/components';

import plus from '../../../../../assets/images/plus_s.png';
import {fadeIn} from "../../../../../styled/StyledComponent";

interface StyledComponentProps {
      width?: string;
      display?: string;
      justifyContent?: string;
  }
  
  export type ClassesChapter = {
      id?: string | undefined;
      category?: string;
      chapterTitle?: string;
      jwPlayerList: ChapterVideo[];
  };
  
  // jwPlayerTitle
  export type ChapterVideo = {
      id: string;
      title: string;
      fileName?: string;
      preview: boolean;
  };
  const structure = {
      id:"",
      // category: "",
      chapterType:"",
      chapterTitle: "",
      jwPlayerList: [
          {
              id: "",
              title: "",
              fileName: "",
              preview: false,
          },
      ],
  };
  const viedoStructure = {
      id: "",
      title: "",
      fileName: "",
      preview: false,
  };
  
  const Videos: React.FC = () => {
      const menu = useRecoilValue(selectedMenu);
      const navigate = useNavigate()
      const {
          state: { createId },
      } = useLocation();
      const setSubmit = useSetRecoilState(activeSubmit);
      const setAlert = useSetRecoilState(Alert)
      const [isLoading, setIsLoading] = useState(false)
      const [submitFire, setSubmitFire] = useRecoilState(fireSubmit);    
      const { data: classesData, stepData } = useGetClassData(createId, "getClassVideoById",isLoading);
      const [chapterData, setChapterData] = useState([structure]);
      const [percentage, setPercentage] = useState(0);
      const [transcriptList, setTranscriptList] = useState([{
          fileName:"",
          file:null,
      }]);
      const onClickPreview = (index: number, videoIndex: number, status: boolean) => {
          const copyData = cloneDeep(chapterData);
          copyData[index].jwPlayerList[videoIndex].preview = !status;
          setChapterData(cloneDeep(copyData));
      };
  
      const transcriptFileInput = useRef(null);
  
      const checkFileExtension = (fileName: string) => {
          const allowedExtensions =
              /(\.pdf|\.doc|\.docx|\.txt|\.rtf|\.html|\.csv|\.ppt|\.pptx|\.jpeg|\.png|\.gif)$/i;
          if (!allowedExtensions.exec(fileName)) {
              return false;
          }
          return true;
      };
  
      const isRightFileExtension = (file: any) => {
          const fileName = file?.name;
          if (!fileName) return false;

          const isRight = checkFileExtension(fileName);
          return isRight;
      };
  
      const handleTranscriptFile = (index:number) => {
          const file = transcriptFileInput.current?.files[0];
          const copy = cloneDeep(transcriptList);
          copy[index] = file
          // if (!isRightFileExtension(file)) {
          //     alert("Please upload a file with the right extension");
          //     return;
          // }
          copy[index].fileName = file?.name;
          copy[index].file = file;
          setTranscriptList(copy);
      };
  
      const onClickCategoryMenu = (item, key, index) => {
          const copyData = cloneDeep(chapterData);
          copyData[index] = {
              ...copyData[index],
              [key]: item,
          };
          setChapterData(cloneDeep(copyData));
      };
  
      const onChangeVideoInput = (
          e: React.ChangeEvent<HTMLInputElement>,
          index: number,
          videoIndex: number
      ) => {
          const value = e.target.value;
          const copyData = cloneDeep(chapterData);
          copyData[index]["jwPlayerList"][videoIndex].title = value;
          console.log("copyData", copyData);
          setChapterData([...cloneDeep(copyData)]);
      };
  
      const setArrayData = (
          state: any,
          method: string,
          setState: any,
          index: number,
          viedoIndex?: number
      ) => {
          const data = cloneDeep(state);
          if (method === "add") {
              data[index]["jwPlayerList"]?.push(viedoStructure);
          } else {
              data[index]["jwPlayerList"]?.splice(viedoIndex, 1);
          }
  
          setState([...cloneDeep(data)]);
      };
  
      const setChapterList = (isAdd: boolean, index?: number) => {
          const copyData = cloneDeep(chapterData);
          if (isAdd) {
              copyData.push(structure);
              setChapterData([...copyData]);
          } else {
              copyData.splice(index, 1);
              setChapterData([...copyData]);
          }
      };
  
      const setTranscriptItems = (isAdd: boolean, index?: number) => {
          const copyData = cloneDeep(transcriptList);
          if (isAdd) {
              copyData.push({
                  fileName:"",
                  file:null,
              });
              setTranscriptList([...copyData]);
          } else {
              copyData.splice(index, 1);
              setTranscriptList([...copyData]);
          }
      };
  
      const deleteVideoId = async () => {
          // await classesAPI.deleteClassByVideoId()
      }
      const handleUploadJWP = async (event, index, videoIndex, chapterData) => {
          const copyData = cloneDeep(chapterData);
          const file = event.target.files[0];
            console.log("file",file);
          if (copyData[index]["jwPlayerList"][videoIndex]?.title.length === 0) {
              setAlert({
                  isActive:true,
                  text:"Please enter a video title.",
                  desc:"Enter a title",
                  type:"info",
                  color:"blue",
                  time: 1300
              })
              return;
          }
          if (!file) {
              return;
          }
          try {
              const videoElement = document.createElement('video');
              videoElement.preload = 'metadata';
              videoElement.src = URL.createObjectURL(file);

              await new Promise(resolve => {
                  videoElement.onloadedmetadata = () => {
                      //@ts-ignore
                      resolve();
                  };
              });
              const duration = videoElement.duration;
              console.log("@duration",duration);
              const result = await commonAPI.postVideoMetadata({
                  data: {
                      metadata: {
                          duration:duration,
                          title: copyData[index]["jwPlayerList"][videoIndex]?.title,
                          language:"en"
                      },
                      upload: {
                          mimeType: file?.type,
                      },
                      fileName: file?.name,
                      preview: true,
                      drm:true
                  },
              });
              if (result) {
                  console.log("result", result);
                  const uploadLink = result.data.upload_link;
                  copyData[index]["jwPlayerList"][videoIndex].id = result?.data?.jwPlayerId;
                  copyData[index]["jwPlayerList"][videoIndex].fileName = file?.name;
                  copyData[index]["jwPlayerList"][videoIndex].preview = result?.data?.preview || true;
                  if (result?.data?.jwPlayerId) {
                      setChapterData(cloneDeep(copyData));
                  };
  
                  const fileReader = new FileReader();
                  fileReader.readAsArrayBuffer(file);
                  fileReader.onload = async () => {
                      const arrayBuffer = fileReader.result as ArrayBuffer;
                      const uint8Array = new Uint8Array(arrayBuffer);
                      const buffer = uint8Array.slice();
                      axios({
                          method: "PUT",
                          url: uploadLink,
                          headers: {
                              "Content-Type": file?.type,
                          //     attachments
                          },
                          data: new Blob([buffer]),

                          onUploadProgress: (progressEvent) => {
                              const percentage =
                                  (progressEvent.loaded / (progressEvent.total || 1)) * 100;
                              const percentCompleted = Math.round(percentage);
                              setPercentage(percentCompleted);
                          },
                      }).then(async (res) => {
                          console.log("video", res);
                          await commonAPI.getJwpToken(result?.data?.jwPlayerId)
                              .then(resultData => {
                                  console.log("@resultData",resultData);
                              })
                          await putVideoData(false, copyData)
                          .then(res => {
                            classesAPI.getClassVideoById(createId)
                            .then(res => {
                                dataSetting(res?.data)
                            })
                          })
                      });
                  };
              }
          } catch (error) {
              console.log("error", error);
          }
      };

      console.log("@chapterData",chapterData);
      const putVideoData = async (routing = true, chapter) => {
          await classesAPI
              .putClassVideo(createId, {
                  data: getFormData(chapter),
              })
              .then((res) => {
                // setIsLoading(v => !v)
                if(routing){
                    console.log("upload", res);
                    navigate("/create/quiz",{
                      state:{
                          createId:createId
                      }
                    })
                }
               
              });
      };
      const handleRemoveTranscriptList = async (index) => {
          if (window.confirm('Are you sure you want to delete this transcript?')) {
               
            const formData = new FormData();
            formData.append('transcriptOrder', index.toString());
            formData.append('jwplayerIds', '');
  
            await classesAPI?.deleteClassVideo(createId,{
              data:formData
            })
          }
      };
      const removeVideo = async (id, videoId) => {
          await classesAPI.deleteVideoById(createId, id, videoId)
      };
      const getFormData = (chapterData) => {
        const formData = new FormData();
        if (transcriptList.length > 0) {
            transcriptList.forEach((transcript, index) => {
                if (transcript?.file) {
                    const transcriptBlob = new Blob([transcript?.file], {
                        type: transcript.file.type,
                    });
                    formData.append("transcriptFiles", transcriptBlob, transcript?.file?.name);
                }
            });
        };

        const chapters = cloneDeep(chapterData)?.map(item => {
            item.jwPlayerList = item?.jwPlayerList?.filter(item => {
                delete item?.createdDatetime;
                delete item?.updatedDatetime;
                delete item?.isDrm;
                delete item?.playTime;
                return !isEmpty(item?.id);
            });
            // item.chapterType = returnChapterId(item?.chapterTitle)?.chapterType;

            item.chapterType = item?.chapterType;
            item.orderNumber = returnChapterId(item?.chapterType)?.orderNumber || 0;
            if(isEmpty(item.id)){
                delete item.id;
            };
            return item;
        });
        formData.append("newChapters",JSON.stringify({chapters:cloneDeep(chapters)}))
        // copy?.forEach((item, index) => {
        //     Object.entries(item).forEach((chItem) => {
        //         if(chItem[0] === "jwPlayerList"){
        //             // @ts-ignore
        //             [...chItem[1]].forEach((jwItem, jwIndex) => {
        //                 Object.entries(jwItem).forEach((fItem, fIndex) => {
        //                     if(fItem[0] !== "deleted" && fItem[0] !== "playTime"){
        //                         formData.append(`newChapters[${index}].jwPlayerList[${jwIndex}].${fItem[0]}`,String(fItem[1]))
        //                     }
        //                 })
        //             })
        //         }else{
        //             formData.append(`newChapters[${index}].${chItem[0]}`,String(chItem[1]))
        //         }
        //     })
        // })
        return formData;
      };
  
      console.log('transcriptList2', transcriptList)
  
      const onClickDeleteChapter = async (id) => {
          await classesAPI.deleteClassChapter(createId,id, null)
          .then(res => {
              console.log('suc', res)
          })
      }
  
      const dataSetting = (stepData) => {
          if(stepData?.transcripts && stepData?.transcripts?.length !== 0){
              setTranscriptList(stepData?.transcripts);
          };        
          if(stepData?.chapters && stepData?.chapters?.length !== 0){
              const viedoData = [
                  {
                      id: "",
                      title: "",
                      fileName: "",
                      preview: false,
                  },
              ]
              const mapData = stepData?.chapters?.map((item) => {
                  return {
                      id:item?.id,
                      chapterType:item?.category,
                      chapterTitle:item?.chapterTitle,
                      jwPlayerList:cloneDeep(item?.videos).length === 0 ? viedoData :
                      cloneDeep(item?.videos)
                  }
              })
              setChapterData(cloneDeep(mapData));
          };  
      };
  
      useEffect(()=>{
          dataSetting(stepData);
      },[stepData]);
  
      useEffect(()=>{
          if(!isEmpty(chapterData)){
              setSubmit(true)
          }else{
              setSubmit(false)
          }
      },[]);
  
      useEffect(()=>{
          if(submitFire){
              setSubmitFire(false)
            //   putVideoData();
          }
      },[submitFire])
  
      console.log("stepData", stepData);
      console.log("chapterData", chapterData);
  
      return (
          <Container>
              <Contents>
                  <h2
                      style={{
                          fontWeight: "700",
                          fontSize: 26,
                          marginBottom: 20,
                      }}
                  >
                      Class videos
                  </h2>
                  {chapterData.map((item, index) => {
                      return (
                          <FormItems>
                              <FormInner>
                                  <Row display={"flex"}>
                                      {chapterData?.length !== 1 && (
                                          <CloseButton
                                              onClick={() => {
                                                  setChapterList(false, index);
                                                  if(!isEmpty(item?.id)){
                                                      onClickDeleteChapter(item?.id)
                                                  }    
                                              }}
                                          >
                                              <CloseIcon />
                                          </CloseButton>
                                      )}
                                      <Col style={{ width: "25%" }}>
                                          <FormBox>
                                              <dt>Category <strong>*</strong></dt>
                                              <dd>
                                                  <FormBoxItemWrap>
                                                      <li>
                                                          <FormItem>
                                                              <DropdownMenu
                                                                  selected={
                                                                      chapterData[index]?.chapterType
                                                                  }
                                                                  altText={"Category"}
                                                                  items={["INTRODUCTION", "CHAPTER", "CONCLUSION"]}
                                                                  state={"chapterType"}
                                                                  index={index}
                                                                  onClick={onClickCategoryMenu}
                                                              />
                                                          </FormItem>
                                                      </li>
                                                  </FormBoxItemWrap>
                                              </dd>
                                          </FormBox>
                                      </Col>
                                      <Col
                                          className={"chapterTitle"}
                                          style={{ width: "100%", flex: 1, marginLeft: 15 }}>
                                          <FormBox>
                                              <dt>Chapter title <strong>*</strong></dt>
                                              <dd>
                                                  <FormBoxItemWrap>
                                                      <li>
                                                          <FormItem>
                                                              <input
                                                                  type="text"
                                                                  placeholder="Enter a title"
                                                                  value={item?.chapterTitle}
                                                                  onChange={(e) => {
                                                                      const copy =
                                                                          cloneDeep(chapterData);
                                                                      copy[index].chapterTitle =
                                                                          e.target.value;
                                                                      setChapterData(cloneDeep(copy));
                                                                  }}
                                                              />
                                                              <TextLength>{150 - item?.chapterTitle?.length}</TextLength>
                                                          </FormItem>
                                                      </li>
                                                  </FormBoxItemWrap>
                                              </dd>
                                          </FormBox>
                                      </Col>
                                  </Row>
                              </FormInner>
                              <FormItemDivider />
                              <VideoItemsWrap>
                                  <h3>Videos <strong>*</strong></h3>
                                  {item?.jwPlayerList?.map((videoItem, videoIndex) => (
                                      <VideoItems
                                          className={"practice"}
                                          style={{ width: "100%" }}>
                                          <CheckBox
                                              onClick={() => {
                                                  onClickPreview(
                                                      index,
                                                      videoIndex,
                                                      videoItem?.preview
                                                  );
                                              }}
                                          >
                                              <div className={videoItem?.preview ? "on" : ""}>
                                                  <Check />
                                              </div>
                                              <span>Preview</span>
                                          </CheckBox>
                                          <FormItem
                                              style={{
                                                  flex: 1,
                                                  marginRight: 15,
                                              }}
                                              className={"videoTitle"}
                                          >
                                              <input
                                                  type="text"
                                                  onChange={(e) => {
                                                      onChangeVideoInput(e, index, videoIndex);
                                                  }}
                                                  value={videoItem?.title || ""}
                                                  placeholder="Title"
                                              />
                                              <TextLength>{150 - videoItem?.title?.length}</TextLength>
                                          </FormItem>
                                          <FormItem
                                              className={"choose"}
                                              style={{
                                                  maxWidth: "35%",
                                                  width: "100%",
                                                  flex: 1,
                                                  marginRight: 15,
                                              }}
                                          >
                                              <input
                                                  type="text"
                                                  placeholder="Choose files"
                                                  readOnly={true}
                                                  value={videoItem?.fileName || ""}
                                              />
                                          </FormItem>
                                          <Browse
                                              className={"chooseBtn"}
                                              style={{
                                                  marginRight: 15,
                                              }}
                                          >
                                              <PlusIcon/>
                                              <span>Browse</span>
                                              <input
                                                  type={"file"}
                                                  onChange={(e) => {
                                                      handleUploadJWP(e, index, videoIndex, chapterData)                                                   
                                                      e.target.value = "";
                                                  }}
                                              />
                                          </Browse>
                                          {/*{item?.jwPlayerList?.length !== 1 && (*/}
                                          {/*    <RemoveButton*/}
                                          {/*        className={"removeButton"}*/}
                                          {/*        onClick={async () => {                                                    */}
                                          {/*            setArrayData(*/}
                                          {/*                chapterData,*/}
                                          {/*                "remove",*/}
                                          {/*                setChapterData,*/}
                                          {/*                index,*/}
                                          {/*                videoIndex*/}
                                          {/*            );*/}
                                          {/*            if(item?.id){*/}
                                          {/*               await removeVideo(item?.id,)*/}
                                          {/*            }*/}
                                          {/*        }}*/}
                                          {/*    >*/}
                                          {/*        <Remove />*/}
                                          {/*    </RemoveButton>*/}
                                          {/*)}*/}
                                          <RemoveButton
                                              style={{
                                                  opacity:item?.jwPlayerList?.length == 1 ? 0 : 1,
                                                  pointerEvents:item?.jwPlayerList?.length == 1 ? "none" : "all",
                                              }}
                                              className={"removeButton"}
                                              onClick={async () => {

                                                  if(item?.id){
                                                      await removeVideo(item?.id, videoItem?.id)
                                                          .then(res => {
                                                              setArrayData(
                                                                  chapterData,
                                                                  "remove",
                                                                  setChapterData,
                                                                  index,
                                                                  videoIndex
                                                              );
                                                          })
                                                          .catch(e => {
                                                              console.log("@e",e);
                                                          })
                                                  }
                                              }}
                                          >
                                              <Remove />
                                          </RemoveButton>
                                      </VideoItems>
                                  ))}
                                  <div
                                      style={{
                                          width: "100%",
                                          display: "flex",
                                          justifyContent: "flex-end",
                                      }}
                                  >
                                      <AddButton
                                          style={{height:40}}
                                          className={"addVideo"}
                                          onClick={() => {
                                              setArrayData(chapterData, "add", setChapterData, index);
                                          }}
                                      >
                                          <span>Add video</span>
                                      </AddButton>
                                  </div>
                              </VideoItemsWrap>
                          </FormItems>
                      );
                  })}
  
                  <AddChapter
                      onClick={() => {
                          setChapterList(true);
                      }}
                  >
                      <PlusIcon />
                      <span>Add chapter</span>
                  </AddChapter>
                  <Divider />
                  <TranscriptTitle>Transcript</TranscriptTitle>
                  {transcriptList?.map((item, index) => (
                      <Transcript>
                          <VideoItems
                              className={"practice"}
                          >
                              <FormItem
                                  className={"choose"}
                                  style={{ width: "100%", marginRight: 15 }}>
                                  <input
                                      type="text"
                                      placeholder="Choose files"
                                      value={item?.fileName || ""}
                                  />
                              </FormItem>
                              <Browse
                                  className={"choose"}
                                  style={{ marginRight: 15 }}>
                                  <PlusIcon/>
                                  <input type={"file"} ref={transcriptFileInput}
                                      onChange={()=>{handleTranscriptFile(index)}}
                                  />
                                  <span>Browse</span>
                              </Browse>
                              {transcriptList?.length !== 1 && (
                                  <RemoveButton
                                      className={"removeButton transcript"}
                                      onClick={async () => {
                                          setTranscriptItems(false, index);
                                          await handleRemoveTranscriptList(index)
                                      }}
                                  >
                                      <Remove />
                                  </RemoveButton>
                              )}
                          </VideoItems>
                      </Transcript>
                  ))}
                  <Browse
                      onClick={() => {
                          setTranscriptItems(true);                        
                      }}
                      className={"add"}
                      style={{ marginRight: 15, width: 106, height:40 }}
                  >
                      <span style={{ marginLeft: 0, marginRight: 10 }}>Add</span>
                      <PlusIcon/>
                  </Browse>
              </Contents>
              <ButtonItems 

              justifyContent={"flex-end"}>
                  <Browse
                      onClick={async ()=>{
                          await putVideoData(false, chapterData)
                          navigate("/create/learning material",{
                              state:{
                                  createId:createId
                              }
                          })
                      }}
                      className={"prev"}
                      style={{ marginRight: 15, width: 100, height: 40 }}>
                      <span style={{ marginLeft: 0 }}>Previous</span>
                  </Browse>
                  <button
                      className={`continue ${
                          (chapterData[0]?.chapterTitle !== "" && 
                              chapterData[0]?.chapterType !== "" &&
                              chapterData[0]?.jwPlayerList[0]?.id !== "") ? "on" : ""}`}
                      onClick={()=>{putVideoData(true, chapterData)}}
                  >Continue</button>
              </ButtonItems>
          </Container>
      );
  };
  export default Videos;
  
  const Container = styled.div`
      animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
      //overflow-y: scroll;
      scrollbar-width: thin;
      scrollbar-color: transparent transparent;
  
      &::-webkit-scrollbar {
          width: 0;
      }
  
      &::-webkit-scrollbar-thumb {
          background-color: transparent;
      }
  `;
  
  const Contents = styled.div`
      padding: 20px;
      overflow: hidden;
      h2{
          font-size: 26px;
          font-weight: 700;
          line-height: 26px;
          letter-spacing: 0em;
          text-align: left;
      }
  `;
  
  const Row = styled.div<StyledComponentProps>`
      display: ${(props) => props.display};
      justify-content: space-between;
      margin-bottom: 15px;
      @media screen and (max-width: 768px) {
          flex-direction: column;
          width: 100%;
          & > div{
              width: 100%;
          }
      }
  `;
  const Col = styled.div<StyledComponentProps>`
      width: calc((100% - 18px) / 2);
      @media screen and (max-width: 768px) {
          width: 100%!important;
          &.chapterTitle{
              padding-top: 5px;
              margin-left: 0px!important;    
          }   
      }
  `;
  const Divider = styled.div`
      width: calc(140%);
      transform: translateX(-20%);
      height: 1px;
      background: #333;
      opacity: 0.3;
  `;
  const FormBox = styled.dl`
      > dt {
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          color: #333333;
          /* opacity: 0.8; */
          margin-bottom: 8px;
          > strong {
              font-size: 13px;
              font-weight: 600;
              color: #da1414;
              display: inline-block;
              margin-left: 1px;
              vertical-align: top;
          }
      }
  `;
  const FormBoxItemWrap = styled.ul`
      > li {
          font-size: 16px;
          margin: 8px 0 0 0;
      }
  `;
  
  const FormItem = styled.div`
      position: relative;
      transition: all 0.2s;
      @media screen and (max-width: 768px) {
          width: 100%!important;
          min-width: 100%!important;
          max-width: 100%!important;
      }
      > input[type="text"],
      select,
      textarea {
          transition: all 0.2s;
          width: 100%;
          font-family: Europa-Regular;
          font-size: 16px;
          outline: none;
          border-radius: 8px;
          border: solid 1px rgba(51, 51, 51, 0.3);
          padding: 12px 16px;
          &::placeholder {
              color: #ddd;
          }
          
      }
      > input[type="text"] {
          height: 48px;
 
      }
      > select {
          height: 48px;
          -webkit-appearance: none;
          appearance: none;
      }
  `;
  
  const TextLength = styled.span`
      color: rgba(51, 51, 51, 0.6);
      font-weight: 700;
      position: absolute;
      right: 16px;
      top: 17px;
  `;
  
  const SelectArrow = styled.div`
      position: absolute;
      right: 16px;
      top: 15px;
  `;
  
  const ThumbnailWrap = styled.div`
      color: #333;
      font-size: 16px;
  `;
  
  const ThumbnailTitle = styled.h5`
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 15px;
      > strong {
          font-size: 13px;
          font-weight: 600;
          color: #da1414;
          display: inline-block;
          margin-left: 1px;
          vertical-align: top;
      }
  `;
  
  const ThumbnailText = styled.p`
      margin-bottom: 15px;
      line-height: 22px;
  `;
  
  const ThumbnailUpload = styled.div`
      width: 100%;
      height: 180px;
      padding: 9px 8px;
      border: 1px dashed rgba(51, 51, 51, 0.6);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
          padding: 0;
          border: 0;
          background: none;
          line-height: 0;
          cursor: pointer;
      }
  `;
  
  const ThumbnailView = styled.div`
      width: 100%;
      height: 100%;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      &::after {
          width: 100%;
          height: 100%;
          position: absolute;
          background: #000;
          opacity: 0.5;
          content: "";
      }
  `;
  
  const ThumbnailButtonList = styled.ul`
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      > li {
          margin: 0 4px;
      }
  `;
  
  const ThumbnailUploadButton = styled.button`
      width: 100%;
      height: 100%;
      > span {
          display: block;
          font-size: 18px;
          font-family: Europa-Regular;
          margin-top: 10px;
          line-height: 100%;
      }
  `;
  
  const ButtonItems = styled.div<StyledComponentProps>`
      padding: 25px 20px;
      display: flex;
      justify-content: space-between;
      border-top: solid 1px rgba(51, 51, 51, 0.3);

      button {
          &.continue{
              font-family: Europa-Regular;
              font-size: 18px;
              font-weight: 400;
              line-height: 18px;
              text-align: left;
              border: solid 1px #ddd;
          }
          transition: all 0.2s;
          width: 100px;
          height: 40px;
          border: 0;
          cursor: pointer;
          padding: 11px 15px 11px 14px;
          color: #fff;
          border-radius: 6px;
          background: #ddd;
          pointer-events: none;
          border: solid 1px #333;
          &.on{
              background: #333;
              color: #fff;
              pointer-events: all;
              border: solid 1px #333;
              &:hover{
                  background: #fff;
                  color: #333;
              }
          }
      }
  `;
  
  const FormItems = styled.div`
      border: solid 1px #33333360;
      border-radius: 15px;
      overflow: hidden;
      margin-bottom: 20px;
      box-shadow: 0px 0px 6px 0px #33333329;
  `;
  const FormInner = styled.div`
      padding: 15px 15px 10px 15px;
      position: relative;
  `;
  const FormItemDivider = styled.div`
      width: 100%;
      height: 1px;
      background: #33333360;
  `;
  const VideoItemsWrap = styled.div`
      padding: 30px 15px 20px 15px;
      margin-bottom: 4px;
      h3{
          margin-bottom: 4px;
      }
      @media screen and (max-width: 768px) {
          h3{
              
              margin-bottom: 10px;
          }
      }
      h2 {
          margin-bottom: 3px;
          font-size: 16px;
          font-weight: 400;
      }
      h3{
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          color: #333;

          > strong {
              font-size: 13px;
              font-weight: 600;
              color: #da1414;
              display: inline-block;
              margin-left: 1px;
              vertical-align: top;
          }
      }
  `;
  const VideoItems = styled.div`
      display: flex;
      transition: all 0.2s;
      align-items: center;
      margin-bottom: 16px;
      position: relative;
      @media screen and (max-width: 768px) {
          flex-direction: column;
          width: 100%;
          align-items: flex-start;
          &.practice{
              width: 100%!important;
              .choose{
                  width: calc(100% - 30px)!important;
                  max-width: calc(100% - 30px)!important;
                  min-width: calc(100% - 30px)!important;
              }
              .chooseBtn{
                  width: calc(100% - 30px)!important;
                  max-width: calc(100% - 30px)!important;
                  min-width: calc(100% - 30px)!important;
              }
              .removeButton{
                  position: absolute;
                  top: 134px;
                  transform: translateY(-50%);
                  &.transcript{
                      top: 50%;
                      width: 24px!important;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      padding: 10px 0;
                  }
                  svg{
                      width: 20px!important;
                      height: 20px;
                  }
                  left: calc(100% - 20px);
                  z-index: 999;
              }
          }
          & > div{
              width: 100%!important;
              margin-right: 0!important;
              margin-bottom: 8px;
          }
      }
  `;
  const CheckBox = styled.div`
      display: flex;
      cursor: pointer;
      margin-right: 13px;
      align-items: center;
      span {
          color: #212529;
          /* font-family: Helvetica Neue; */
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
      }
  
      div {
          cursor: pointer;
          transition: all 0.2s;
          padding: 0;
          width: 16px;
          height: 16px;
          margin-right: 8px;
          border-radius: 4px;
          border: solid 1px #333;
          display: flex;
          align-items: center;
          justify-content: center;
          &.on {
              border: solid 1px #ddc160;
              background: #ddc160;
          }
      }
  `;
  const Browse = styled.div`
      position: relative;
      transition: all 0.2s;
      cursor: pointer;
      height: 48px;
      border-radius: 8px;
      padding: 0 18.5px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: solid 1px #333;
      flex: 1;
      width: 100%;
      max-width: 120px;
      &.prev{
          width: 100px;
          max-width: 100px;
          padding: 0!important;
      }
      &.add{
          width: 100px;
          max-width: 100px;
          padding: 0!important;
      }
      &:hover{
          background: #333;
          border-color: #333;
          span{
              color: #fff!important;    
          }
          
          svg{
              path{
                  fill: #fff!important;
              }
          }
          span{
              color: #fff;

          }
      }
      @media screen and (max-width: 768px) {
          width: 100%!important;
          min-width: 100%;
          max-width: 100%;
          min-height: 46px;
          &.prev{
              min-width: 95px;
              max-width: 95px;
              min-height: 40px;
          }
          &.add{
              min-width: 95px;
              max-width: 95px;
              min-height: 40px;
              height: 40px;
          }
      }
      span {
          margin-left: 10px;
          font-size: 18px;
          color: #333;
      }
      img {
          width: 100%;
          height: 100%;
          object-fit: contain;
      }
      svg{
          width: 16px;
          height: 16px;
          path{
              fill: #333!important;
          }
      }
      input {
          position: absolute;
          width: 100%;
          height: 100%;
          background: #333;
          opacity: 0;
          z-index: 3;
      }
  `;
  const CloseButton = styled.div`
      background: #333;
      position: absolute;
      right: 0;
      z-index: 2;
      top: 0;
      width: 51px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      @media screen and (max-width: 768px) {
          width: 51px!important;
          height: 25px!important;
      }
      &:hover{
          svg{
              transform: scale(1.1);
          }
      }
      svg {
          pointer-events: none;
      }
  `;
  const RemoveButton = styled.div`
      @media screen and (min-width: 768px) {
          box-sizing: border-box;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: solid 1px rgba(51, 51, 51, 0);
          border-radius: 50%;
          cursor: pointer;
          &:hover {
              border: solid 1px #333;
              border-radius: 50%;

              svg {
                  transition: all 0.3s;
                  color: #333 !important;
                  stroke: #333 !important;

                  path {
                      fill: #333 !important;
                      opacity: 1 !important;
                      fill-opacity: 1;
                  }
              }
          }
      }
  `;
  
  const AddButton = styled.div`
      //height: 48px;
      cursor: pointer;
      transition: all 0.2s;
      border-radius: 8px;
      &:hover {
          color: #fff;
          background: #333;
      }
      display: flex;
      align-items: center;
      justify-content: center;
      border: solid 1px #333;
      font-size: 18px;  
      color: #333;
      padding: 7px 16px;
      min-width: 120px;
  `;
  
  const AddChapter = styled.div`
      background: #333;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      width: 160px;
      height: 40px;
      justify-content: center;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s;
      border: solid 1px #333;
      &:hover{
          background: #fff;
          border: solid 1px #333;
          span{
              color: #333;    
          }
          svg{
              path{
                  fill: #333;
              }
          }
      }
 
      span {
          color: #fff;
          font-size: 18px;
          margin-left: 10px;
          font-weight: 400;
      }
  `;
  
  const Transcript = styled.div`
      h3 {
          margin-top: 20px;
          margin-bottom: 14px;
          font-size: 26px;
          font-weight: 700;
      }
  `;
  
  const TranscriptTitle = styled.h3`
      font-size: 26px;
      font-weight: 700;
      margin-bottom: 16px;
      margin-top: 20px;
      line-height: 26px;
      letter-spacing: 0em;
      text-align: left;
  `;
  